import { render, staticRenderFns } from "./ofPublicList.vue?vue&type=template&id=38358409&scoped=true&"
import script from "./ofPublicList.vue?vue&type=script&lang=js&"
export * from "./ofPublicList.vue?vue&type=script&lang=js&"
import style0 from "./ofPublicList.vue?vue&type=style&index=0&id=38358409&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38358409",
  null
  
)

export default component.exports